import { connect } from 'react-redux'
import { compose } from 'recompose'
import { formatPhoneNumber } from 'helpers/phone-number'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import SpecialOrder from './SpecialOrder'

const mapStateToProps = (state) => {
  const storePhoneNumber = getCurrentStorePhoneNumber(state)
  return {
    storePhoneNumber,
    formattedStorePhoneNumber: formatPhoneNumber(storePhoneNumber)
  }
}

export default compose(
  connect(mapStateToProps)
)(SpecialOrder)
